import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import jsonVersions from '@cms_root/assets/json-versions.json';

@Injectable()
export class JsonInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let newReq = request;

    if (request.url.match(/.json$/)) {
      const version = jsonVersions?.[request.url];

      if (version) {
        newReq = newReq.clone({
          params: newReq.params.append('v', version)
        });
      }
    }

    return next.handle(newReq);
  }
}
